// Payment form validation constants
export const CARD_NUMBER_CHECK_LENGTH = 15;
export const PASSWORD_LENGTH = 2;
export const EXPIRY_DATE_LENGTH = 5;
export const USER_INFO_LENGTH = 6;

// Card number segment lengths  
export const CARD_SEGMENT_LENGTHS = [4, 4, 4, 4]; // 4-4-4-4 format (16 digits total)